/*
 * Ruff Life theme: the only script, deferred and optional. Everything works without it:
 * the menu and FAQ are <details> elements and the size picker is a normal form field.
 */
(function () {
  // Close the mobile menu with Escape and return focus to its button.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-mobile-nav][open]');
    if (!open) return;
    open.removeAttribute('open');
    var summary = open.querySelector('summary');
    if (summary) summary.focus();
  });

  // Size picker: show the chosen size's price and whether it can be added to the cart.
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var select = form.querySelector('[data-variant-select]');
    var button = form.querySelector('[data-add-button]');
    var labels = form.querySelector('[data-labels]');
    var section = form.closest('.main-product');
    var priceBox = section ? section.querySelector('[data-price]') : null;
    if (!select || !button) return;
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var available = option.getAttribute('data-available') === 'true';
      button.disabled = !available;
      if (labels) button.textContent = available ? labels.getAttribute('data-add') : labels.getAttribute('data-sold-out');
      if (priceBox) {
        // Price, and the struck-through price only when this size really is on sale.
        var current = priceBox.querySelector('.price__current');
        var compareWrap = priceBox.querySelector('[data-compare]');
        var compare = priceBox.querySelector('.price__compare');
        var saleLabel = priceBox.querySelector('[data-sale-label]');
        var comparePrice = option.getAttribute('data-compare-price');
        if (current) current.textContent = option.getAttribute('data-price');
        if (compare) compare.textContent = comparePrice || '';
        if (compareWrap) compareWrap.hidden = !comparePrice;
        if (saleLabel) saleLabel.hidden = !comparePrice;
        priceBox.classList.toggle('price--sale', Boolean(comparePrice));
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    });
  });
})();
